import "react-whatsapp-widget/dist/index.css"
import WhatsAppWidget from "react-whatsapp-widget"

const WhatsappContact = () => {
  return (
    <WhatsAppWidget
      phoneNumber="905428570360"
      message="Merhaba, nasıl yardımcı olabilirim?"
      textReplyTime="Genellikle bir saat içinde yanıt verir."
      companyName="İş Kıbrıs Destek"
      sendButton="Gönder"
    />
  )
}

export default WhatsappContact
